var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ny-main',{attrs:{"title":"Infinities 管理员平台","platform":"admin","route-data":_vm.routeData}})}
var staticRenderFns = []

export { render, staticRenderFns }